/**
 * Created by Ivan on 10.08.2026
 */

Object.assign(VirtualProducts, {
    stickers2_0: {
        title: "StickersBook2.products.specialPack",
        currency: "hard",
        spentEvent: cleverapps.EVENTS.SPENT.STICKERS2_3,
        price: RewardsConfig.stickers2_0.hardPrice,
        icon: bundles.stickers2_shop.frames.stickers_chest_0,
        availableAfterCollection: 2,
        reward: RewardsConfig.stickers2_0.reward
    },

    stickers2_1: {
        title: "StickersBook2.products.mediumPack",
        currency: "hard",
        spentEvent: cleverapps.EVENTS.SPENT.STICKERS2_2,
        price: RewardsConfig.stickers2_1.hardPrice,
        icon: bundles.stickers2_shop.frames.stickers_chest_1,
        reward: RewardsConfig.stickers2_1.reward
    },

    stickers2_2: {
        title: "StickersBook2.products.smallPack",
        currency: "hard",
        spentEvent: cleverapps.EVENTS.SPENT.STICKERS2_1,
        price: RewardsConfig.stickers2_2.hardPrice,
        icon: bundles.stickers2_shop.frames.stickers_chest_2,
        reward: RewardsConfig.stickers2_2.reward
    },

    stickers2_3: {
        title: "StickersBook2.products.smallPack",
        currency: "points",
        spentEvent: cleverapps.EVENTS.SPENT.STICKERS2_4,
        price: RewardsConfig.stickers2_3.pointsPrice,
        icon: bundles.stickers2_shop.frames.stickers_chest_3,
        reward: RewardsConfig.stickers2_3.reward
    },

    stickers2_4: {
        title: "StickersBook2.products.mediumPack",
        currency: "points",
        spentEvent: cleverapps.EVENTS.SPENT.STICKERS2_5,
        price: RewardsConfig.stickers2_4.pointsPrice,
        icon: bundles.stickers2_shop.frames.stickers_chest_4,
        reward: RewardsConfig.stickers2_4.reward
    },

    stickers2_5: {
        title: "StickersBook2.products.specialPack",
        currency: "points",
        spentEvent: cleverapps.EVENTS.SPENT.STICKERS2_6,
        price: RewardsConfig.stickers2_5.pointsPrice,
        icon: bundles.stickers2_shop.frames.stickers_chest_5,
        reward: RewardsConfig.stickers2_5.reward
    }
});
